<template>
  <div class="lead-container">
    <p>
      姓名：

      {{ lead.name }}

      <span
        v-if="isDuplicatedLead"
        @click="showDuplicatedLeadDialog = true"
        class="font-red cursor-pointer"
      >
        重复客资
      </span>
    </p>

    <p style="display: flex; align-items: center" v-if="showChannelAccount">
      <span style="flex-shrink: 0">渠道账号：</span
      ><platform-icon :platform="lead.platform" />{{ lead.channel_account }}
    </p>

    <p v-if="showSource">来源：{{ lead.source_text }}</p>

    <p v-if="lead.gender === 2">性别： 女</p>
    <p v-if="lead.gender === 1">性别： 男</p>

    <p v-if="region">地区：{{ region }}</p>

    <p>联系方式：</p>

    <div class="contact-container pl-8">
      <div class="flex align-middle my-2" v-if="lead.mobile">
        <span class="block w-3/4">手机：{{ lead.mobile }}</span>
        <van-button
          plain
          type="primary"
          size="mini"
          class="px-4 ml-4 flex-none"
          v-if="isMobile"
          @click="dial(lead.mobile)"
        >
          拨打
        </van-button>
        <van-button
          plain
          type="primary"
          size="mini"
          class="px-4 ml-4 flex-none"
          v-if="!isMobile"
          v-clipboard:copy="lead.mobile"
          v-clipboard:success="onSuccess"
        >
          复制
        </van-button>
      </div>

      <div
        class="flex align-middle my-2"
        v-if="lead.mobile_status && lead.mobile_status !== 'unchecked'"
      >
        <span class="flex w-3/4" style="flex-wrap: nowrap">
          空号检测结果：<mobile-validation-result
            :status="lead.mobile_status"
          />
        </span>
      </div>

      <div class="flex align-middle my-2" v-if="lead.mobile_loc">
        <span class="flex w-3/4" style="flex-wrap: nowrap">
          号码归属地：{{ lead.mobile_loc }}
        </span>
      </div>

      <div class="flex align-middle my-2" v-if="lead.mobile_check_time">
        <span class="flex w-3/4" style="flex-wrap: nowrap">
          检测时间：{{ lead.mobile_check_time }}
        </span>
      </div>

      <div class="flex align-middle my-2" v-if="lead.weixin">
        <div class="block w-3/4">
          微信：{{ lead.weixin }}
          <p v-if="lead.weixin_source_image">
            （根据
            <span class="font-blue" @click="showSourceImageDialog = true"
              >图片</span
            >
            智能识别）
          </p>
        </div>
        <van-button
          plain
          type="primary"
          size="mini"
          class="px-4 ml-4 flex-none"
          v-clipboard:copy="lead.weixin"
          v-clipboard:success="onSuccess"
          >复制</van-button
        >
      </div>

      <div class="flex align-middle my-2" v-if="lead.qq">
        <span class="block w-3/4"> Q Q ：{{ lead.qq }}</span>
        <van-button
          plain
          type="primary"
          size="mini"
          class="px-4 ml-4 flex-none"
          v-clipboard:copy="lead.qq"
          v-clipboard:success="onSuccess"
          >复制</van-button
        >
      </div>

      <div class="flex align-middle my-2" v-if="lead.qrcode_text">
        <div class="block w-3/4">
          二维码：
          <span class="font-blue" @click="showImageDialog = true"
            >查看图片</span
          >
        </div>
      </div>
    </div>

    <div class="my-2" v-if="lead.ad_adgroup_id">
      广告ID：{{ lead.ad_adgroup_id }}
    </div>

    <div class="my-2" v-if="lead.ad_account_id">
      广告主ID：{{ lead.ad_account_id }}
    </div>

    <div class="my-2" v-if="lead.fmc_account_id">
      组件账户ID：{{ lead.fmc_account_id }}
    </div>

    <div class="my-2" v-if="lead.remark">
      备注：
      <div class="pl-8 my-2" style="word-break: break-all">
        {{ lead.remark }}
      </div>
    </div>

    <p v-for="field in customFields" :key="field.field_key">
      <span class="font-bold">{{ field.field_name }}：</span>
      <span>{{ field.value }}</span>
    </p>
  </div>

  <van-dialog v-model:show="showSourceImageDialog" confirmButtonText="关闭">
    <div style="text-align: center; margin: 0 auto; margin-top: 20px">
      <img :src="lead.weixin_source_image + '!q80'" alt="" style="width: 80%" />
    </div>
  </van-dialog>

  <van-dialog
    v-model:show="showDuplicatedLeadDialog"
    title="重复客资"
    confirmButtonText="关闭"
  >
    <div style="padding: 20px">
      <lead :lead="lead.exist_user" v-if="lead.exist_user"></lead>
    </div>
  </van-dialog>
</template>

<script>
import { Button } from "vant";
import { Dialog } from "vant";
import { Notify } from "vant";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { isMobile } from "@/utils/host";
import PlatformIcon from "@/components/PlatformIcon.vue";
import MobileValidationResult from "./MobileValidationResult.vue";
import { areaList } from "@/data/location";

export default {
  components: {
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [VueQrcode.name]: VueQrcode,
    PlatformIcon,
    MobileValidationResult,
  },

  data: function () {
    return {
      showImageDialog: false,
      showSourceImageDialog: false,
      showDuplicatedLeadDialog: false,
      isMobile: isMobile(),
      isDuplicatedLead: false,
      region: "",
      customFields: [],
    };
  },

  props: {
    lead: {},
  },

  computed: {
    showChannelAccount() {
      return Number(this.lead.show_channel_account) === 1;
    },

    showSource() {
      return (
        Number(this.lead.show_source) === 1 &&
        Boolean(this.lead.source_text?.trim())
      );
    },
  },

  created() {
    this.isDuplicatedLead = !!Object.keys(this.lead.exist_user || {})?.length;

    this.customFields = (this.lead.custom_fields || []).filter((field) => {
      return ![
        "gender",
        "mobile",
        "weixin",
        "qq",
        "weixin_source_image",
      ].includes(field.field_key) && field.value !== "";
    });

    if (this.lead.region_code) {
      const region_code = this.lead.region_code.toString();
      const provinceCode = region_code.slice(0, 2) + "0000";
      const regionArr = [];
      regionArr.push(areaList.province_list[provinceCode] || "");

      const cityCode = region_code.slice(0, 4) + "00";
      regionArr.push(areaList.city_list[cityCode] || "");

      regionArr.push(areaList.county_list[region_code] || "");

      this.region = regionArr.filter((item) => !!item).join("-");
    }
  },

  methods: {
    onSuccess() {
      Notify({ type: "success", message: "复制成功" });
    },

    dial(number) {
      if (!number.includes("+86") || number.indexOf("86") !== 0) {
        number = "86" + number;
      }

      window.open("tel:+" + number);
    },

    duplicateLead() {},
  },
};
</script>

<style scoped>
p {
  margin: 10px 0;
}

.font-blue {
  color: rgb(2, 167, 240);
}

.pl-8 {
  padding-left: 2rem;
}

.align-middle {
  vertical-align: middle;
}

.flex {
  display: flex;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.w-3\/4 {
  width: 75%;
}

.block {
  display: block;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.ml-4 {
  margin-left: 1rem;
}

.qrcode {
  max-width: 80%;
  margin: 10px 0;
}

:deep(a),
:deep(a:visited) {
  color: var(--van-primary-color);
}

.flex-none {
  flex: none;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
